/**
 * Replace part of a textarea's value by asking the browser to type it, so the
 * edit joins the field's own undo stack.
 *
 * A controlled React input assigns `.value` directly, and browsers discard
 * their undo history when that happens. An autocomplete or chip insertion
 * therefore leaves Ctrl+Z unable to reach anything typed before it -- the edit
 * is not an entry in the stack, it is the reason the stack is gone.
 *
 * `execCommand` is deprecated but remains the only way to write into a field as
 * if the user had. It emits a real `input` event, so React's onChange still
 * sees the change and state stays in step, and the caret lands after the
 * inserted text without being placed by hand.
 *
 * Returns false where the browser refuses or does not implement it -- jsdom
 * among them -- leaving the caller to fall back to setting state directly, at
 * the cost of that one edit not being undoable.
 */
export function replaceRangeWithText(
  textarea: HTMLTextAreaElement,
  start: number,
  end: number,
  text: string,
): boolean {
  if (typeof document.execCommand !== 'function') return false;

  textarea.focus();
  textarea.setSelectionRange(start, end);

  try {
    return document.execCommand('insertText', false, text);
  } catch {
    return false;
  }
}
